import Resource from './Resource'

class SpainClassification extends Resource {
  static urlRoot() {
    return '/contracts/spain/classifications'
  }
}

export default SpainClassification
